import { Option, Schema } from "effect";
import { Step, stepFor, type SteppedTag } from "./steps.ts";

export { Step };

// TODO: Bound instants to valid Date milliseconds; safe integers beyond ±8.64e15 decode but break FSRS.
export const Instant = Schema.Int.pipe(Schema.brand("Instant"));
export type Instant = typeof Instant.Type;

export const Days = Schema.Finite.check(Schema.isGreaterThan(0)).pipe(Schema.brand("Days"));
export type Days = typeof Days.Type;

export const Difficulty = Schema.Finite.check(Schema.isBetween({ minimum: 1, maximum: 10 })).pipe(Schema.brand("Difficulty"));
export type Difficulty = typeof Difficulty.Type;

export const Retention = Schema.Finite.check(Schema.isBetween({ minimum: 0.7, maximum: 0.97 })).pipe(Schema.brand("Retention"));
export type Retention = typeof Retention.Type;

export const PositiveInt = Schema.Int.check(Schema.isGreaterThan(0)).pipe(Schema.brand("PositiveInt"));
export type PositiveInt = typeof PositiveInt.Type;

export const NonNegativeInt = Schema.Int.check(Schema.isGreaterThanOrEqualTo(0)).pipe(Schema.brand("NonNegativeInt"));
export type NonNegativeInt = typeof NonNegativeInt.Type;

export const Rating = Schema.Literals(["again", "good"]);
export type Rating = typeof Rating.Type;

export const Memory = Schema.Struct({
  stability: Days,
  difficulty: Difficulty,
  lastReviewAt: Instant,
  reps: PositiveInt,
  lapses: NonNegativeInt,
}).check(Schema.makeFilter((m) => m.lapses < m.reps || `lapses ${m.lapses} must be below reps ${m.reps}`));
export type Memory = typeof Memory.Type;

const withinSteps = (tag: SteppedTag) =>
  Schema.makeFilter<{ readonly step: Step }>(
    (s) => Option.isSome(stepFor(tag, s.step)) || `step ${s.step} is past the last ${tag} step`,
  );

const New = Schema.Struct({ tag: Schema.Literal("new") });
const Learning = Schema.Struct({ tag: Schema.Literal("learning"), memory: Memory, step: Step, dueAt: Instant }).check(
  withinSteps("learning"),
);
const Review = Schema.Struct({ tag: Schema.Literal("review"), memory: Memory, dueAt: Instant });
const Relearning = Schema.Struct({ tag: Schema.Literal("relearning"), memory: Memory, step: Step, dueAt: Instant }).check(
  withinSteps("relearning"),
);

export const CardState = Schema.Union([New, Learning, Review, Relearning]);
export type CardState = typeof CardState.Type;

export const Reviewed = Schema.Union([Learning, Review, Relearning]);
export type Reviewed = typeof Reviewed.Type;
